export const common = {
  companyName: '小松弹簧工业株式会社',
  companyNameEn: 'Komatsu Spring Industrial Co., Ltd.',
  slogan: '精细的构思',
  heroTagline: '以品质取胜的弹簧专家',
  heroSubtitle: '通过精密弹簧的订单生产，满足客户的每一项需求',
  productInfo: '产品介绍',
  companyProfile: '公司介绍',
  blog: '博客',
  contact: '联系我们',
  recruit: '招聘信息',
  news: '最新消息',
  newsAll: '查看全部消息',
  torsionSpring: '扭转弹簧',
  compressionSpring: '压缩弹簧',
  tensionSpring: '拉伸弹簧',
  wireForming: '线材成型加工',
  torsionSpringEn: 'TORSION SPRING',
  compressionSpringEn: 'COMPRESSION SPRING',
  tensionSpringEn: 'TENSION SPRING',
  wireFormingEn: 'WIRE FORMINGS',
  address: '〒143-0013 东京都大田区大森南5丁目3番18号',
  tel: '电话: 03-3743-0231(总机)',
  fax: '传真: 03-3743-0235',
  copyright: '© Komatsu Spring Industrial Co., Ltd.',
  features: '公司特色',
  springTypes: '弹簧种类',
  products: '产品',
  usage: '用途',
  message: '总经理致辞',
  companySummary: '公司概要',
  equipment: '设备',
  office: '办事处',
  history: '公司历史',
  quality: '质量方针/环境方针',
  esg: 'ESG',
  registrations: '注册・会员团体',
  japanese: '日本語',
  english: 'English',
  chinese: '中文(简体)',
  chineseTraditional: '中文(繁體)',
  
  // Footer translations
  companyAddress: '〒143-0013 东京都大田区大森南5丁目3番18号',
  quickLinks: '快速链接',
  home: '首页',
  featuresTitle: '公司特色',
  businessHours: '营业时间',
  businessHoursDetail: '周一至周五 8:30-17:30（周六、周日、节假日休息）',
  
  // Features page content
  featuresSubtitle: '我们引以为傲的高品质弹簧，源于精细的构思和彻底的客户至上主义。',
  delicateDesign: '精细的构思',
  delicateDesignDesc: '基于"即使是一个小弹簧，也是构成精密产品心脏部分的重要部件"的理念进行技术开发。',
  prototypeToMass: '从样品到批量生产',
  prototypeToMassDesc1: '从1个样品开始承接订单。',
  prototypeToMassDesc2: '从样品开始就使用机械设备制造，确保批量生产时的同等品质。',
  qualityControl: '彻底的质量管理',
  qualityControlDesc1: '在工厂内建立品质:',
  qualityControlDesc1Detail: '从产品接单到制造直至交付的各个工序中，建立彻底的管理和检查体制，实现更完善的产品制造。',
  qualityControlDesc2: '质量保证:',
  qualityControlDesc2Detail: '在产品交付时提供保证可靠品质的"产品检查成绩表"。',
  qualityControlDesc3: '交期管理:',
  qualityControlDesc3Detail: '运用计算机进行彻底的交期管理。',
  qualityControlDesc4: '品质维持:',
  qualityControlDesc4Detail: '公司内部制作治具工具类、模具，能够维持高精度的品质。',
  // Products page content
  productsTitle: '弹簧种类·产品·用途',
  productsSubtitle: '1000种需求，1000种技术',
  detailInfo: '详细信息和视频可通过以下链接查看。',
  torsionSpringDetail: '扭转弹簧',
  compressionSpringDetail: '压缩弹簧',
  tensionSpringDetail: '拉伸弹簧',
  wireFormingDetail: '线材成型加工',
  microSpring: '微细弹簧·医疗用特殊弹簧',
  otherProducts: '其他·工业产品以外',
  torsionSpringDesc: '扭转弹簧是围绕线圈中心轴承受扭转载荷(扭矩)的弹簧。',
  torsionSpringSpec: '制造实绩:线径0.03㎜〜2.0㎜左右 圆线',
  compressionSpringDesc: '一般称为压簧的这种弹簧，压缩载荷(线圈轴载荷)与挠度成正比。',
  compressionSpringSpec1: '制造实绩:线径0.02㎜〜2.0㎜ 圆线、扁线',
  compressionSpringSpec2: '形状实绩:长卷线圈、圆锥形、桶形、不等节距、不等外径',
  tensionSpringDesc: '拉伸螺旋弹簧本质上与压缩弹簧相同。(线圈部分通常为密绕)',
  tensionSpringSpec: '制造实绩:线径0.08㎜〜2.0㎜左右',
  wireFormingDesc: '使用成型机等设备进行各种成型加工的"线工艺弹簧"',
  wireFormingSpec1: '制造实绩:线径0.1㎜〜2㎜左右',
  wireFormingSpec2: '材料形状:圆线、扁线',
  materials: '材料',
  materialTypes: '钢琴线、不锈钢线、铂金线、磷青铜线、各种镀层线、其他',
  materialShapes: '圆线、扁线',
  builtInProducts: '组装产品实例',
  builtInProductsSubtitle: '被用于各种产品中',
  electricalProducts: '电气产品',
  electricalProductsList: '工业产品、家电、相机、打印机、燃气设备、火灾报警器、电表、其他',
  communication: '通信',
  communicationList: '手机、充电台、接线端子、时钟、其他',
  medicalEquipment: '医疗器械',
  medicalEquipmentList: '导管治疗器、内窥镜装置、电刀、活检用设备、健康器具、脉搏血氧仪、血压计、体重计、计步器、理容器械、其他',
  vehicleEquipment: '车辆设备',
  vehicleEquipmentList: '汽车、摩托车、割草机、巴士、其他',
  otherUsage: '其他',
  otherUsageList: '珠宝、锁具、音响设备、钓具、文具、玩具、家具、其他',
  usageTitle: '用途',
  usageSubtitle: '针对每个用途的专门技术应对',
  electricalUsage: '开关、连接器、电池导电用、导电部件、接触探针、打印机点阵针、传感器、其他',
  communicationUsage: '手表表冠、手表日历、铰链、天线、相机快门、相机镜头周边、其他',
  medicalUsage: '导丝用、内窥镜插入部用、投影用标记、夹子、活检机用、其他',
  vehicleUsage: '化油器、车内电装部件用、刹车开关、其他',
  otherDetailUsage: '过滤器、固定件、耳环、唱针臂支撑、拟饵框架、卷轴、文具夹、圆珠笔部件、其他',
  
  // Product detail pages common
  banner: '全部定制生产的精密设备微观科学',
  clickToEnlarge: '点击放大显示',
  manufacturingRecord: '制造实绩',
  characteristics: '特征',
  mainApplications: '主要用途',
  technicalSpecs: '技术规格',
  qualityAssurance: '质量保证',
  contactUs: '联系我们',
  
  // Torsion Spring page - 追加
  torsionSpringApp1: '汽车门铰链',
  torsionSpringApp2: '洗衣机盖开闭机构',
  torsionSpringApp3: '电子设备盖开闭',
  torsionSpringApp4: '手表上弦机构',
  torsionSpringApp5: '玩具驱动部件',
  
  // Compression Spring page - 追加
  compressionSpringFeature: '压缩弹簧是最常见的弹簧之一，具有在轴向压缩载荷作用下收缩的特性。载荷与挠度成正比关系，被用于各种机械部件和电子设备中。',
  compressionSpringApp1: '汽车悬架',
  compressionSpringApp2: '圆珠笔内部机构',
  compressionSpringApp3: '电子设备开关',
  compressionSpringApp4: '医疗设备部件',
  compressionSpringApp5: '工业机械缓冲材料',
  hardWire: '硬钢线（SWC）',
  flatWire: '扁线材料',
  specialShapes: '特殊形状对应',
  conicalSpring: '圆锥弹簧（锥形线圈）',
  barrelSpring: '桶形弹簧',
  unevenPitch: '不等节距弹簧',
  unevenDiameter: '不等外径弹簧',
  longCoil: '长卷线圈',
  squareWireSpring: '方线弹簧',
  precisionMeasurement: '精密测量',
  precisionMeasurementDesc: '使用千分尺级精密测量设备',
  loadTest: '载荷试验',
  loadTestDesc: '对所有批次进行弹簧载荷试验',
  qualityCertificate: '质量保证书',
  qualityCertificateDesc: '发行附带检查数据的质量保证书',
  
  // Tension Spring page
  tensionSpringFeature: '拉伸弹簧具有在轴向拉伸载荷作用下伸长的特性。线圈部分通常为密绕，两端加工成钩状。适用于利用与压缩弹簧相反方向力的用途。',
  tensionSpringApp1: '测量仪表指针复位机构',
  tensionSpringApp2: '闭门器',
  tensionSpringApp3: '电子部件连接机构',
  tensionSpringApp4: '医疗设备操作部件',
  tensionSpringApp5: '汽车电缆',
  hookTypes: '钩形状种类',
  roundHook: '圆钩',
  roundHookDesc: '最常见的圆形钩形状',
  angleHook: '角钩',
  angleHookDesc: '可调节角度的形状',
  specialHook: '特殊钩',
  specialHookDesc: '根据用途定制的形状',
  materialsList: '材料',
  pianoWire: '钢琴线（SWP-A, SWP-B）',
  stainlessWire: '不锈钢线（SUS304, SUS316）',
  phosphorBronze: '磷青铜线',
  berylliumCopper: '铍铜线',
  specialAlloy: '其他特殊合金线',
  processingRange: '加工范围',
  wireDiameter: '线径',
  outerDiameter: '外径',
  freeLength: '自由长度',
  effectiveCoils: '有效圈数：可协商',
  hookAccuracy: '钩精度',
  hookAccuracyDesc: '严格管理钩形状的尺寸精度',
  tensileTest: '拉伸试验',
  tensileTestDesc: '对所有产品进行规定载荷的拉伸试验',
  durabilityTest: '耐久性试验',
  durabilityTestDesc: '通过重复载荷确认耐久性',
  
  // Wire Forming page
  wireFormingFeature: '线材成型加工是将线材成型为各种形状的技术。使用成型机，高精度制造复杂的三维形状部件。也称为"线工艺弹簧"，可应对多样化用途。',
  wireFormingApp1: '夹子、订书钉',
  wireFormingApp2: '电子部件连接端子',
  wireFormingApp3: '医疗设备精细部件',
  wireFormingApp4: '手表·精密仪器部件',
  wireFormingApp5: '装饰品·配饰',
  processingTypes: '加工种类',
  bendingProcess: '弯曲加工',
  bendingProcessDesc: '将直线材料弯曲成任意角度的加工',
  coilingProcess: '卷绕加工',
  coilingProcessDesc: '卷绕成螺旋状或线圈状',
  cuttingProcess: '切断加工',
  cuttingProcessDesc: '按指定尺寸精密切断',
  formingProcess: '成型加工',
  formingProcessDesc: '复合三维形状的成型',
  supportedMaterials: '对应材料',
  highCarbonWire: '钢琴线（高碳钢线）',
  stainlessVariety: '各种不锈钢线',
  copperWire: '铜线·黄铜线',
  titaniumWire: '钛线',
  platedWire: '各种镀层线',
  materialShape: '材料形状：圆线、扁线',
  processingLength: '加工长度',
  accuracy: '精度',
  minBendRadius: '最小弯曲半径：线径的1.5倍',
  applicationFields: '应用领域',
  electronicPrecision: '电子·精密设备',
  connectionTerminals: '连接端子·连接器',
  sensorParts: '传感器部件',
  boardFixing: '电路板固定部件',
  switchMechanism: '开关机构',
  medicalDevices: '医疗设备',
  catheterParts: '导管部件',
  endoscopeParts: '内窥镜用部件',
  surgicalInstruments: '外科器械',
  inspectionParts: '检查设备部件',
  autoIndustrial: '汽车·产业设备',
  electricalParts: '电装部件',
  fixingClips: '固定夹',
  mechanismParts: '机构部件',
  dimensionInspection: '尺寸检查',
  dimensionInspectionDesc: '使用三维测量设备进行精密尺寸检查',
  appearanceInspection: '外观检查',
  appearanceInspectionDesc: '表面质量·形状精度的全数检查',
  functionalTest: '功能试验',
  functionalTestDesc: '实际使用条件下的动作确认试验',
  
  // Micro Spring page
  microSpringDesc: '从超小型弹簧到医疗设备专用特殊弹簧，采用高精度技术制造。',
  microSpringTitle: '微细弹簧',
  microSpringEn: 'MICRO SPRING',
  medicalSpringTitle: '医疗用特殊弹簧',
  medicalSpringEn: 'MEDICAL SPECIAL SPRING',
  microFeature1: '使用线径0.02mm起的超细线材',
  microFeature2: '外径1mm以下的超小型弹簧',
  microFeature3: '最适合精密电子设备',
  microFeature4: '高精度尺寸管理',
  microApp1: '手表内部机构',
  microApp2: '精密测量仪器',
  microApp3: '相机机构部件',
  microApp4: '微型开关',
  medicalFeature1: '使用生物相容性材料',
  medicalFeature2: '高安全性和可靠性',
  medicalFeature3: '定制设计对应',
  medicalFeature4: '严格的质量管理',
  medicalApp1: '导管部件',
  medicalApp2: '内窥镜设备',
  medicalApp3: '外科用器械',
  medicalApp4: '生物传感器',
  microSpringSpecs: '微细弹簧规格',
  medicalMaterials: '医疗用材料',
  biocompatibleStainless: '生物相容性不锈钢',
  titaniumAlloy: '钛合金：轻量·高强度材料',
  mp35n: 'MP35N：高性能合金',
  platinumWire: '铂金线：高纯度材料',
  manufacturingProcess: '制造工艺',
  materialSelection: '材料选定',
  materialSelectionDesc: '根据用途选定和验证最佳材料',
  precisionProcessing: '精密加工',
  precisionProcessingDesc: '使用专用设备进行高精度成型加工',
  qualityInspection: '质量检查',
  qualityInspectionDesc: '尺寸·载荷·外观的全数检查',
  cleanPackaging: '清洁包装',
  cleanPackagingDesc: '在洁净室环境中进行最终包装',
  electronicDevices: '电子设备',
  electronicDevicesDesc: '智能手机、平板电脑、可穿戴设备的内部部件',
  medicalEquipmentDesc: '导管、内窥镜、外科器械、检查设备',
  precisionInstruments: '精密仪器',
  precisionInstrumentsDesc: '手表、测量仪器、光学设备的精密部件',
  opticalEquipment: '光学设备',
  opticalEquipmentDesc: '相机、显微镜、镜头驱动机构',
  automationEquipment: '自动化设备',
  automationEquipmentDesc: '机器人、精密执行器',
  analyticalInstruments: '分析仪器',
  analyticalInstrumentsDesc: '分析装置、检查装置的微细部件',
  certifications: '质量保证·认证',
  isoCertification: 'ISO认证',
  isoCertificationDesc: '符合国际质量管理标准',
  precisionInspectionTitle: '精密检查',
  precisionInspectionDesc: '使用最新测量设备进行全数检查',
  traceability: '可追溯性',
  traceabilityDesc: '制造履历的完全管理',
  medicalCertification: '医疗认证',
  medicalCertificationDesc: '医疗设备用材料认证',
  
  // Other Products page
  otherProductsDesc: '除工业产品外，还制造日常生活中使用的各种产品的弹簧部件。',
  jewelryAccessories: '珠宝·配饰',
  earringClasp: '耳环·耳钉的扣件',
  necklaceClasp: '项链扣',
  broochClasp: '胸针扣',
  watchBandParts: '表带部件',
  stationery: '文具',
  penMechanism: '圆珠笔内部机构',
  clipsBindings: '夹子·活页夹',
  mechanicalPencil: '自动铅笔部件',
  staplerParts: '订书机机构部件',
  toysHobbies: '玩具·爱好',
  toyMechanism: '玩具驱动机构',
  modelParts: '模型可动部件',
  fishingReelParts: '钓具卷轴部件',
  lureFrame: '拟饵框架',
  furnitureInterior: '家具·室内装饰',
  chairCushion: '椅子座垫',
  sofaStructure: '沙发内部结构',
  drawerMechanism: '抽屉开闭机构',
  doorCloser: '闭门器',
  audioEquipment: '音响设备',
  recordNeedleArm: '唱针臂支撑',
  speakerDiaphragm: '扬声器振膜',
  instrumentParts: '乐器部件',
  headphoneAdjustment: '耳机调节机构',
  securityLocks: '锁具·安全',
  lockMechanism: '锁内部机构',
  padlockParts: '挂锁部件',
  doorLock: '门锁机构',
  securityDevice: '安全装置',
  manufacturingFeatures: '制造特点',
  customDesign: '定制设计',
  customDesignDesc: '根据客户用途进行完全定制设计。提供兼顾设计性和功能性的产品。',
  diverseFinishes: '多样化表面处理',
  diverseFinishesDesc: '对应电镀、涂装、研磨等各种表面处理。实现美观外观和耐久性。',
  smallLotSupport: '小批量对应',
  smallLotSupportDesc: '从样品到小批量生产灵活对应。也接受个人客户的订单。',
  shortDelivery: '短交期',
  shortDeliveryDesc: '凭借丰富经验和高效生产体制，可实现短交期交付。',
  usedMaterials: '使用材料',
  metalMaterials: '金属材料',
  brassWire: '黄铜线',
  surfaceTreatment: '表面处理',
  goldPlating: '镀金',
  silverPlating: '镀银',
  nickelPlating: '镀镍',
  chromePlating: '镀铬',
  variousPainting: '各种涂装',
  specialMaterials: '特殊材料',
  colorWire: '彩色线材',
  otherConsultation: '其他可协商',
  qualityService: '质量与服务',
  designConsultation: '设计咨询',
  designConsultationDesc: '专业人员从设计阶段开始提供支持',
  prototypeSupport: '样品对应',
  prototypeSupportDesc: '从1个开始可制作样品',
  qualityGuarantee: '质量保证',
  qualityGuaranteeDesc: '通过全数检查进行质量保证',
  rapidDelivery: '快速配送',
  rapidDeliveryDesc: '短交期制造·配送',
  contactMessage: '欢迎随时咨询',
  contactSubMessage: '再小的咨询我们也会认真对待',
  
  // Contact page
  'contact.title': '联系我们',
  'contact.subtitle': '关于弹簧的任何问题都可以咨询我们',
  'contact.intro1': '全部采用定制生产，从样品到批量生产均可对应。',
  'contact.intro2': '如有图纸或实物，请告知我们。',
  'contact.requiredNote': '※ 请填写所有带星号的项目。',
  'contact.formTitle': '联系表单',
  'contact.companyName': '公司名称',
  'contact.department': '部门名称',
  'contact.fullName': '姓名',
  'contact.address': '地址',
  'contact.telephone': '电话号码',
  'contact.email': '电子邮箱',
  'contact.specification': '规格',
  'contact.preferredDeliveryDate': '希望交货日期',
  'contact.preferredUnitPrice': '希望单价',
  'contact.characters': '字',
  'contact.submit': '提交',
  'contact.submitting': '提交中...',
  'contact.submitSuccess': '已收到您的咨询。谢谢。',
  'contact.submitError': '提交失败。请重试。',
  'contact.requiredFields': '请填写所有必填项。',
  'contact.specificationLimit': '请在500字以内输入规格。',
  'contact.urgentContact': '如有紧急情况',
  'contact.urgentContactDesc': '也可通过电话和传真联系。',
  'contact.phone': '电话',
  'contact.fax': '传真',
  
  // Recruit page
  'recruit.title': '招聘信息',
  'recruit.subtitle': '寻找具有弹性和灵活思维的人才',
  'recruit.intro': '我们寻找像弹簧一样具有弹性和灵活思维的人才。也欢迎希望回乡就业的人士咨询。',
  'recruit.jobListings': '招聘要求',
  'recruit.tokyoOffice': '东京总部工厂',
  'recruit.ogawaraFactory': '大河原工厂',
  'recruit.akitaFactory': '秋田太田町工厂',
  'recruit.location': '工作地点',
  'recruit.positions': '招聘人数',
  'recruit.salary': '起薪',
  'recruit.person': '名',
  'recruit.yen': '日元',
  'recruit.university': '大学毕业',
  'recruit.technical': '高等专科学校、专门学校毕业',
  'recruit.highSchool': '高中毕业',
  'recruit.graduate': '研究生院',
  'recruit.tokyoAddress': '东京都大田区大森南5丁目3番18号',
  'recruit.ogawaraAddress': '宫城县柴田郡大河原町字甲子町1-1',
  'recruit.akitaAddress': '秋田县大仙市太田町斉内字北开182-4',
  'recruit.commonInfo': '共通',
  'recruit.salaryIncrease': '加薪',
  'recruit.salaryIncreaseDetail': '每年一次（4月）',
  'recruit.bonus': '奖金',
  'recruit.bonusDetail': '每年两次（7月、12月）：根据业绩',
  'recruit.workingHours': '工作时间',
  'recruit.workingHoursDetail': '8:30〜17:30（含70分钟休息）根据工作地点和部门可能有所不同',
  'recruit.holidays': '休息日',
  'recruit.holidaysDetail1': '每周休息两天',
  'recruit.holidaysDetail2': '年休息日数 113天（根据公司日历）',
  'recruit.vacation': '假期',
  'recruit.vacationDetail1': '年度带薪假期（按法定）',
  'recruit.vacationDetail2': '特别假期（结婚、丧假、赴任、生育等）',
  'recruit.jobType': '职种',
  'recruit.jobTypeDetail': '生产技术、开发、生产管理（资材采购、外包管理、质量/工序管理等）、事务（营业、总务）',
  'recruit.benefits': '福利待遇等',
  'recruit.benefitsDetail': '各种社会保险齐全、退休金制度、企业年金制度、资格取得支援制度、资格取得时奖励金制度、简易保险（日本邮政）、育儿休职制度、生日礼物等',
  'recruit.companyVideo': '公司介绍视频',
  'recruit.videoNotSupported': '您的浏览器不支持视频标签。',
  'recruit.applicationForm': '应聘表单',
  'recruit.fullName': '姓名',
  'recruit.email': '电子邮箱',
  'recruit.telephone': '电话号码',
  'recruit.address': '地址',
  'recruit.education': '最终学历',
  'recruit.selectEducation': '请选择',
  'recruit.desiredPosition': '希望职位',
  'recruit.desiredLocation': '希望工作地点',
  'recruit.selectLocation': '请选择',
  'recruit.message': '自我介绍・应聘动机',
  'recruit.characters': '字',
  'recruit.submit': '应聘',
  'recruit.submitting': '提交中...',
  'recruit.submitSuccess': '感谢您的应聘。负责人将与您联系。',
  'recruit.submitError': '提交失败。请重试。',
  'recruit.requiredFields': '请填写所有必填项。',
  'recruit.messageLimit': '请在500字以内输入信息。',
  'recruit.contactInfo': '联系方式',
  'recruit.contactAddress': '〒143-0013 东京都大森南5丁目3番18号',
  'recruit.contactDepartment': '东京总部 总务部',
  'recruit.contactTel': 'Tel: 03-3743-0231（总机）',
  'recruit.contactFax': 'Fax: 03-3743-0235',
  
  // Company Message page
  'message.title': '总经理致辞',
  'message.subtitle': '致力于成为客户需要的公司',
  'message.greeting': '感谢您访问我们的网站。',
  'message.content1': '小松弹簧工业株式会社创立于1941年，1952年成立公司。作为精密弹簧的专业制造商，我们已有80多年的历史。',
  'message.content2': '我们的企业理念是"被客户需要"。为了实现这一目标，我们始终贯彻"客户至上主义"，致力于制造高品质的弹簧。',
  'message.content3': '弹簧虽然是小部件，但在各种产品中发挥着重要作用。从工业设备到医疗器械、电子设备、日用品，我们的弹簧被应用于广泛的领域。',
  'message.content4': '我们从1个样品到批量生产都可承接订单，灵活应对客户需求。同时，我们也建立了维持稳定品质和遵守交货期的体制。',
  'message.content5': '今后，我们将继续提高技术水平，提供让客户满意的产品。敬请继续支持。',
  'message.president': '代表董事社长',
  'message.presidentName': '小松 万希子',
  
  // Company Office page
  'office.title': '办事处',
  'office.subtitle': '全国生产·销售网络',
  'office.tokyoTitle': '东京总部工厂',
  'office.tokyoAddress': '〒143-0013 东京都大田区大森南5丁目3番18号',
  'office.tokyoTel': 'Tel: 03-3743-0231（总机）',
  'office.tokyoFax': 'Fax: 03-3743-0235',
  'office.tokyoAccess': '交通',
  'office.tokyoAccessDetail': 'JR大森站步行15分钟 / 京急立会川站步行10分钟',
  'office.ogawaraTitle': '大河原工厂',
  'office.ogawaraAddress': '〒989-1246 宫城县柴田郡大河原町字甲子町1-1',
  'office.ogawaraTel': 'Tel: 0224-53-2336',
  'office.ogawaraFax': 'Fax: 0224-53-2337',
  'office.ogawaraAccessDetail': 'JR大河原站开车5分钟',
  'office.akitaTitle': '秋田太田町工厂',
  'office.akitaAddress': '〒019-1601 秋田县大仙市太田町斉内字北开182-4',
  'office.akitaTel': 'Tel: 0187-88-1333',
  'office.akitaFax': 'Fax: 0187-88-1334',
  'office.akitaAccessDetail': 'JR上境站开车10分钟',
  
  // Company History page
  'history.title': '公司历史',
  'history.subtitle': '80多年的历史与传统',
  'history.1941': '1941年5月：在东京都大田区大森创立小松弹簧制作所',
  'history.1952': '1952年12月：成立小松弹簧工业株式会社',
  'history.1965': '1965年4月：在宫城县设立大河原工厂',
  'history.1985': '1985年3月：设立秋田太田町工厂',
  'history.2002': '2002年2月：取得ISO 9001:2000认证',
  'history.2007': '2007年1月：取得Eco-Action 21认证',
  'history.2015': '转换为ISO 9001:2015',
  'history.present': '现在：在全国运营3个工厂，制造精密弹簧',
  
  // Company CSR page
  'csr.title': '质量方针/环境方针',
  'csr.subtitle': '对质量和环境的承诺',
  'csr.qualityPolicyTitle': '质量方针',
  'csr.isoRegistration': '登记日期：2002年2月1日',
  'csr.isoNumber': '登记证号码：JQA-QM7736',
  'csr.qualityContent1': '在小松弹簧工业株式会社实施的"弹簧"制造活动中，以"被客户需要"为经营理念，在"彻底贯彻客户至上主义"的基本方针下，继续同时推进企业发展的原理"成长与扩大"和"稳定"。',
  'csr.qualityContent2': '今后的课题是随着精密设备产业的快速发展，作为超精密弹簧制造企业提高技术和灵活的构思能力，实现质量的均一化、严守交货期、成本的合理化，遵守确保企业存续所需的利润。',
  'csr.qualityContent3': '制定包括符合客户要求事项及持续改进质量管理体系有效性的承诺在内的质量方针。',
  'csr.qualityStatement': '"以满足客户要求为我公司的事业，持续提供名为信赖的产品"',
  'csr.qualityContent4': '这一质量方针是我公司事业的本质，基本是让全体员工理解这一方针，确保能够可靠地提供预期的产品和服务。每个人通过确实实施规定的事项并对活动负责，就能达成预期的成果。',
  'csr.qualitySignature': '小松弹簧工业株式会社 代表董事社长 小松万希子',
  'csr.environmentalPolicyTitle': '环境经营方针',
  'csr.ecoRegistration': '认证·登记日期：2007年1月18日',
  'csr.ecoNumber': '认证号码：0001270',
  'csr.philosophy': '1. 企业理念',
  'csr.philosophyStatement': '"被客户需要"',
  'csr.philosophyContent': '为了我们能够永恒，必须持续被客户强烈需要。在任何环境下，通过以更优秀的技术制造更优秀的"弹簧"，我们通过企业为社会做贡献。基于Eco-Action 21的理念，考虑"与地球共生"，明确我公司所有业务相关的环境影响，致力于环境友好型企业活动。',
  'csr.policy2': '2. 为了通过环境经营成长为更好的进化组织，整理今后经营中的课题（组织的外部、内部）和机会，通过克服课题成为事业发展的机会。根据事业内容、事业周边状况、事业与环境的关系而变化的课题和机会，必要时进行重新审视。',
  'csr.policy3': '3. 将企业理念与事业活动中的环境负荷相协调，确定应该着手的重点领域。',
  'csr.policy3Item1': '1) 通过削减电力、燃气、汽油，抑制CO₂排放',
  'csr.policy3Item2': '2) 通过废弃物分类·回收利用、削减纸张，抑制废弃物排放',
  'csr.policy3Item3': '3) 通过节水等，削减使用量',
  'csr.policy3Item4': '4) 削减化学物质使用量',
  'csr.policy3Item5': '5) 通过原材料的高效使用，削减制造废弃物',
  'csr.policy3Item6': '6) 推进绿色采购',
  'csr.policy3Item7': '7) 掌握产品含有化学物质，禁止含有、使用',
  'csr.policy4': '4. 通过环境经营活动，努力持续改进环境目标、环境计划，提升环境经营水平。',
  'csr.policy5': '5. 承诺遵守环境相关法规。',
  'csr.policy6': '6. 利用公告、会议、晨会等，让全体员工理解环境经营方针的内容并能够着手实施。',
  'csr.co2Title': 'CO₂削减措施',
  'csr.co2Intro': '小松弹簧工业株式会社为实现可持续社会，积极致力于CO₂排放削减。我们认为环境保护是企业的责任，正在推进以下具体对策。',
  'csr.currentInitiatives': '当前措施',
  'csr.initiative1Title': '・将大河原工厂的电力100%切换为可再生能源',
  'csr.initiative1Detail': '通过使用可再生能源来源的电力，大幅削减了工厂运营伴随的CO₂排放。',
  'csr.initiative2Title': '・全公司LED照明化',
  'csr.initiative2Detail': '引进比传统照明耗电量少的LED，实现节能。',
  'csr.initiative3Title': '・引进电动汽车（1辆）',
  'csr.initiative3Detail': '将部分公司用车EV化，减轻移动伴随的环境负担。',
  'csr.initiative4Title': '・作为"HTT措施宣言企业（东京都）"的活动',
  'csr.initiative4Detail': '向东京都公开表明推进节能·创能·蓄能的姿态，强化措施。',
  'csr.initiative5Title': '・参加"大田Cool Action（大田区）"',
  'csr.initiative5Detail': '参加地区环境活动，与当地一起致力于可持续城市建设。',
  'csr.futureInitiatives': '今后计划',
  'csr.future1Title': '・推进全公司向可再生能源计划的转换',
  'csr.future1Detail': '不仅是工厂，各事业所和办公室也将切换为可再生能源。',
  'csr.future2Title': '・将总部空调设备更新为节能型',
  'csr.future2Detail': '将旧空调设备更换为高效节能型，削减使用电力。',
  'csr.conclusion': '通过这些活动，小松弹簧工业株式会社在将环境负担降至最低的同时，为实现可持续未来做出贡献。',
};
